module.exports = __webpack_public_path__ + "static/media/500023.747cbb81.svg";